import { useParams, Link } from "react-router-dom";
import { BadgeCheck, ShieldX } from "lucide-react";
import { useFetch } from "../lib/hooks";

export default function Verify() {
  const { number } = useParams();
  const { data, loading } = useFetch(`/certificates/verify/${encodeURIComponent(number)}`, [number]);
  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-6">
      <div className="surface max-w-lg w-full p-8 text-center" data-testid="verify-card">
        <p className="caption mb-4">Verifikasi Sertifikat</p>
        {loading && <p className="text-slate-500">Memeriksa...</p>}
        {data && data.valid && (
          <div className="space-y-3">
            <BadgeCheck className="h-14 w-14 text-emerald-600 mx-auto" />
            <h1 className="text-2xl font-bold font-heading text-emerald-700" data-testid="verify-valid">Sertifikat Valid</h1>
            <p className="text-3xl font-bold font-heading text-slate-900">{data.student_name}</p>
            <p className="text-sm text-slate-500">NIK {data.nik} · {data.batch_name}</p>
            <p className="font-mono text-sm text-slate-700">{data.certificate_number}</p>
            <p className="text-xs text-slate-500">Diterbitkan {data.issued_at?.slice(0, 10)}</p>
          </div>
        )}
        {data && !data.valid && (
          <div className="space-y-3">
            <ShieldX className="h-14 w-14 text-red-600 mx-auto" />
            <h1 className="text-2xl font-bold font-heading text-red-700" data-testid="verify-invalid">Sertifikat Tidak Ditemukan</h1>
            <p className="font-mono text-sm text-slate-500">{number}</p>
          </div>
        )}
        <Link to="/login" className="inline-block mt-6 text-xs text-slate-400 hover:text-slate-900">YLMS · Yutaka Learning Management System</Link>
      </div>
    </div>
  );
}
